const Footer = () => {
    return (
        <div>
            {/* ©2021 Cappy AB. Org. nr. 559267-1357. */}
        </div>
    )
}

export default Footer